import React from 'react';
import { useTranslation } from 'react-i18next';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import { pageTitle } from '../../helpers/PageTitle';
import SEO from '../SEO';

export default function BlogDetailsKanceri() {
  const { t } = useTranslation();

  const relatedBlog = [
    {
      title: t('blog.blog1Title'),
      thumbUrl: '/images/blog/blog_1.jpeg',
      date: t('blog.blog1Date'),
      btnText: t('blog.readMore'),
      href: '/blog/dializa-peritoneale',
    },
    {
      title: t('blog.blog2Title'),
      thumbUrl: '/images/blog/blog_2.jpg',
      date: t('blog.blog2Date'),
      btnText: t('blog.readMore'),
      href: '/blog/diabeti',
    },
  ];

  pageTitle('Kanceri | Blog | Incomed');

  return (
    <>
      <SEO title="Kanceri" description="Informacione mbi kancerin, llojet, trajtimin dhe mundësitë moderne të mjekësisë onkologjike." url="/blog/kanceri" />
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={t('blog.blog3Title')} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_date">
              {t('blog.blog3Date')} | Incomed
            </div>
          </div>

        </div>
        <Spacing md="55" />
        <div style={{ maxWidth: '900px' }}>
          <img
            src="/images/blog/blog_3.jpg"
            alt="Kanceri"
            className="w-100 cs_radius_20"
          />
        </div>
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-10">
            <div className="cs_blog_details">
              <h2>{t('blog.blog3Title')}</h2>
              <p>
                {t('blog.blog3Intro')}
              </p>

              <h3>{t('blog.blog3Section1Title')}</h3>
              <p>
                {t('blog.blog3Section1Content')}
              </p>

              <blockquote>
                <p>
                  "{t('blog.blog3Quote')}"
                </p>
              </blockquote>

              <h3>{t('blog.blog3Section2Title')}</h3>
              <p>
                {t('blog.blog3Section2Content')}
              </p>
            </div>
          </div>
        </div>
        <Spacing md="135" lg="100" />
        <h2 className="mb-0 cs_fs_40 cs_medium">{t('blog.relatedArticles')}</h2>
        <Spacing md="57" />
        <div className="row cs_gap_y_40">
          {relatedBlog?.map((item, index) => (
            <div className="col-xl-6 col-md-6" key={index}>
              <Post {...item} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
